import EventQRCode from "./EventQRCode";

export default EventQRCode;
